/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable object-curly-newline */
import store from 'store';
import { AxiosError, AxiosResponse } from 'axios';
import {
  CONTACTS_EDIT_SIDE_PANEL,
  GLOBAL_CONTACTS,
  GLOBAL_CONTACTS_ADD_NEW_CONTACTS,
  GLOBAL_CONTACTS_DELETE_CONTACTS,
  GLOBAL_CONTACTS_SEARCH,
  GLOBAL_CONTACTS_ADD_CONTACTS_TO_LIST,
  GLOBAL_CONTACTS_REMOVED_FROM_LIST,
  GLOBAL_CONTACTS_SELECTION,
  GLOBAL_CONTACTS_ADD_TO_LIST_MODE,
} from 'constants/types/audienceTypesNew';
import { getGlobalContactsService, deleteGlobalPeopleServiceNew, addContactToListService } from 'modules/Services/AudienceServiceNew';
import { IGetGlobalContactsParams, IGetGlobalContactsResponse, IDeleteGlobalContactsParams, IDeleteGlobalContactsResponse } from '../interfaces2';

const { dispatch } = store;

export const loadGlobalContactsAction = (params: IGetGlobalContactsParams, isSearch?: boolean, isSort = false) => {
  console.info(isSort);
  if (isSort) {
    dispatch({ type: isSearch ? GLOBAL_CONTACTS_SEARCH.SORT_LIST : GLOBAL_CONTACTS.SORT_LIST });
  } else {
    dispatch({ type: isSearch ? GLOBAL_CONTACTS_SEARCH.LOAD : GLOBAL_CONTACTS.LOAD });
  }
  getGlobalContactsService(params)
    .then((res: AxiosResponse<IGetGlobalContactsResponse>) => {
      const { data, success, message } = res.data;
      if (success) {
        const { contacts, totalContacts } = data[0];
        dispatch({
          type: isSearch ? GLOBAL_CONTACTS_SEARCH.SUCCESS : GLOBAL_CONTACTS.SUCCESS,
          payload: {
            contacts,
            totalContacts,
            offset: params.offset,
            ...(params.list_id && { totalContactsNotInList: data[0]?.totalContactsWithoutList }),
          },
        });
      } else {
        dispatch({
          type: isSearch ? GLOBAL_CONTACTS_SEARCH.FAIL : GLOBAL_CONTACTS.FAIL,
          payload: {
            message,
          },
        });
      }
    })
    .catch((err: AxiosError<IGetGlobalContactsResponse>) => {
      console.log('err', err);
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        dispatch({
          type: isSearch ? GLOBAL_CONTACTS_SEARCH.FAIL : GLOBAL_CONTACTS.FAIL,
          payload: {
            message: err.message,
          },
        });
      }
    });
};

export const deleteGlobalContactsAction = (params: IDeleteGlobalContactsParams) => {
  dispatch({
    type: GLOBAL_CONTACTS_DELETE_CONTACTS.LOAD,
  });
  return new Promise((resolve, reject) => {
    deleteGlobalPeopleServiceNew(params)
      .then((res: AxiosResponse<IDeleteGlobalContactsResponse>) => {
        const { success, message } = res.data;
        const { deleteAll, contactIds, excludedContactIds } = params;
        if (success) {
          dispatch({
            type: GLOBAL_CONTACTS_DELETE_CONTACTS.SUCCESS,
            payload: { message, deleteAll, contactIds, excludedContactIds },
          });
        } else {
          dispatch({
            type: GLOBAL_CONTACTS_DELETE_CONTACTS.FAIL,
            payload: { message },
          });
        }
        resolve({ success, message });
      })
      .catch((err: AxiosError<IDeleteGlobalContactsResponse>) => {
        dispatch({
          type: GLOBAL_CONTACTS_DELETE_CONTACTS.FAIL,
          payload: { message: err.message },
        });
        // eslint-disable-next-line
        reject({ success: false });
      });
  });
};

export const addToListContactsAction = (params: IDeleteGlobalContactsParams) => {
  dispatch({
    type: GLOBAL_CONTACTS_ADD_CONTACTS_TO_LIST.LOAD,
  });
  return new Promise((resolve, reject) => {
    addContactToListService(params)
      .then((res: AxiosResponse<IDeleteGlobalContactsResponse>) => {
        const { success, message } = res.data;
        const totalContacts = res?.data?.data[0]?.listDetail?.totalContacts;
        const { deleteAll, contactIds, excludedContactIds } = params;
        if (success) {
          dispatch({
            type: GLOBAL_CONTACTS_ADD_CONTACTS_TO_LIST.SUCCESS,
            payload: { message, deleteAll, contactIds, excludedContactIds },
          });
        } else {
          dispatch({
            type: GLOBAL_CONTACTS_ADD_CONTACTS_TO_LIST.FAIL,
            payload: { message },
          });
        }
        resolve({ success, message, totalContacts });
      })
      .catch((err: AxiosError<IDeleteGlobalContactsResponse>) => {
        dispatch({
          type: GLOBAL_CONTACTS_ADD_CONTACTS_TO_LIST.FAIL,
          payload: { message: err.message },
        });
        // eslint-disable-next-line
        reject({ success: false });
      });
  });
};

export const removeFromListContactsAction = (payload: IDeleteGlobalContactsParams) => {
  console.info(payload);
  dispatch({
    type: GLOBAL_CONTACTS_REMOVED_FROM_LIST.REMOVE,
    payload,
  });
};

export const resetGlobalContactsAction = () => {
  dispatch({ type: GLOBAL_CONTACTS.RESET });
};

export const resetGlobalContactsSorting = () => {
  dispatch({ type: GLOBAL_CONTACTS.RESET_SORT });
};

export const resetGlobalContactsSearchedAction = () => {
  dispatch({ type: GLOBAL_CONTACTS_SEARCH.RESET });
};

export const setGlobalContactsSearchTermAction = (searchTerm: string) => {
  dispatch({
    type: GLOBAL_CONTACTS_SEARCH.SET_SEARCH_TERM,
    payload: {
      searchTerm,
    },
  });
};

export const openEditContactSidePanelAction = () => {
  // eslint-disable-next-line
  dispatch({ type: CONTACTS_EDIT_SIDE_PANEL.OPEN });
};

export const closeEditContactSidePanelAction = () => {
  // eslint-disable-next-line
  dispatch({ type: CONTACTS_EDIT_SIDE_PANEL.CLOSE });
};

export const resetCreateNewContactAction = () => {
  // eslint-disable-next-line
  dispatch({ type: GLOBAL_CONTACTS_ADD_NEW_CONTACTS.RESET });
};

export const updateCurrentActiveList = (activeList: string) => {
  store.dispatch({
    type: 'UPDATE_CURRENT_ACTIVE_LIST',
    payload: { activeList },
  });
};

export const globalContactsSelectionSetAction = () => {
  dispatch({ type: GLOBAL_CONTACTS_SELECTION.SET });
};

export const globalContactsSelectionResetAction = () => {
  dispatch({ type: GLOBAL_CONTACTS_SELECTION.RESET });
};

export const globalContactsAddToListModeAction = (mode: boolean) => {
  dispatch({
    type: GLOBAL_CONTACTS_ADD_TO_LIST_MODE.ADD_MODE,
    payload: { mode },
  });
};

export const globalContactsNewContactAddedReset = () => {
  dispatch({
    type: GLOBAL_CONTACTS_ADD_NEW_CONTACTS.RESET_NEW_CONTACT_ADDED,
  });
};

// Reloads global contacts (get_people API called)
export const refreshGlobalContacts = (params: IGetGlobalContactsParams, isSearch?: boolean) => {
  if (isSearch) {
    resetGlobalContactsSearchedAction();
    loadGlobalContactsAction(params, true);
  } else {
    resetGlobalContactsAction();
    loadGlobalContactsAction(params, false);
  }
};

export const updateAudienceFromWorkflow = (isFromWorkflow: boolean) => {
  dispatch({
    type: 'Reset_WORKFLOW_AUDIENCE',
    payload: { isFromWorkflow },
  });
};
